import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';

export class ReceiptModeCreateDto extends BaseModel {
  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  sequence!: number;

  @Expose()
  isDefault!: boolean;

  @Expose()
  receiptAccounts!: { accountId: number; isDefault: boolean }[];

  @Expose()
  description!: string;

  @Expose()
  status!: string;

  @Expose()
  isReferenceFieldEnabled!: boolean;

  @Expose()
  referenceLabel!: string;
}

export class ReceiptModeUpdateDto extends BaseModel {
  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  sequence!: number;

  @Expose()
  isDefault!: boolean;

  @Expose()
  receiptAccounts!: { accountId: number; isDefault: boolean }[];

  @Expose()
  description!: string;

  @Expose()
  status!: string;

  @Expose()
  isReferenceFieldEnabled!: boolean;

  @Expose()
  referenceLabel!: string;
}

export class ReceiptModeFiltersDto extends BaseModel {
  @Expose()
  keyword?: string;

  @Expose()
  status?: string;
}
